module.exports = __webpack_public_path__ + "a46829f17f8f3c4c5a5929be8e3fc599.svg";